import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.263 3.048A5.92 5.92 0 0 1 9.5 1.25a5.92 5.92 0 0 1 4.238 1.798 6.2 6.2 0 0 1 1.746 4.318 6.2 6.2 0 0 1-.599 2.668l2.768 4.914a.75.75 0 0 1-.703 1.116l-2.634-.174-1.174 2.436a.75.75 0 0 1-1.33.042L9.5 14.259l-2.314 4.108a.75.75 0 0 1-1.329-.042L4.683 15.89l-2.633.175a.75.75 0 0 1-.704-1.116l2.769-4.917a6.2 6.2 0 0 1-.598-2.666c0-1.616.626-3.17 1.746-4.318m-.222 8.397-1.707 3.032 1.755-.117a.75.75 0 0 1 .725.423l.77 1.596 1.704-3.024a5.95 5.95 0 0 1-3.247-1.91m5.672 1.91a5.95 5.95 0 0 0 3.247-1.91l1.706 3.031-1.755-.116a.75.75 0 0 0-.726.423l-.77 1.597zm2.66-3.66a4.6 4.6 0 0 1-.708.942 4.42 4.42 0 0 1-3.152 1.345m3.876-2.316-.017.03zm0 0a4.7 4.7 0 0 0 .596-2.3c0-1.23-.477-2.406-1.32-3.27A4.42 4.42 0 0 0 9.501 2.75a4.42 4.42 0 0 0-3.164 1.345 4.68 4.68 0 0 0-1.32 3.271c0 1.23.476 2.407 1.32 3.27a4.42 4.42 0 0 0 3.15 1.346",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }